import { autoinject,bindable } from 'aurelia-framework';
import { AccordionViewModel } from '../../../view-models/accordion-view-model';

@autoinject()
export class Accordion {

    @bindable items:AccordionViewModel[];
    @bindable cardStyle: string;

}